import { useSocket } from '@context/SocketContext'
import { useEffect } from 'react'

interface SocketEventHandlers {
	onTripUpdated?: (data: any) => void
	onItineraryUpdated?: (data: any) => void
	onTravelSegmentsUpdated?: (data: any) => void
	onIdeaUpdated?: (data: any) => void
}

export const useSocketEvents = (handlers: SocketEventHandlers) => {
	const { socket, isConnected } = useSocket()

	useEffect(() => {
		if (!socket || !isConnected) return

		// Set up event listeners
		if (handlers.onTripUpdated) {
			socket.on('trip_updated', handlers.onTripUpdated)
		}

		if (handlers.onItineraryUpdated) {
			socket.on('itinerary_updated', handlers.onItineraryUpdated)
		}

		if (handlers.onTravelSegmentsUpdated) {
			socket.on('travel_segments_updated', handlers.onTravelSegmentsUpdated)
		}

		if (handlers.onIdeaUpdated) {
			socket.on('idea_updated', handlers.onIdeaUpdated)
		}

		// Cleanup listeners on unmount
		return () => {
			if (handlers.onTripUpdated) {
				socket.off('trip_updated', handlers.onTripUpdated)
			}
			if (handlers.onItineraryUpdated) {
				socket.off('itinerary_updated', handlers.onItineraryUpdated)
			}
			if (handlers.onTravelSegmentsUpdated) {
				socket.off('travel_segments_updated', handlers.onTravelSegmentsUpdated)
			}
			if (handlers.onIdeaUpdated) {
				socket.off('idea_updated', handlers.onIdeaUpdated)
			}
		}
	}, [socket, isConnected, handlers])
}
